import { Button, ListGroup } from "react-bootstrap";
import { ExepnditureAccordion, ExepnditureAccordionBody, ExepnditureAccordionCollapseSection, ExepnditureAccordionToggle } from "../expenditureaccordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPenToSquare, faPlus } from "@fortawesome/free-solid-svg-icons";
import styles from '../../../../../styles/expenditureworksheet.module.css';
import formatDollars from "../../../../../utilities/currency-formatter";
import useMessageStore from '../../../../../stores/message-store';
import DeleteButton from "../../../../../components/deletebutton";


const ExpenditureCheck = ({ApplicationID, toggleAddEditMode, addEditIndex, checks = [], expenditureTypemap,refreshFunction, canAdd = false, canUpdate = false, canDelete = false }) => {

    const _getExpenditureTypeText = (expenditureTypeId) => {
        if(expenditureTypeId === null)
            return <span>Type Missing</span>
        else
            return <span>{expenditureTypemap[expenditureTypeId]}</span>
    }

    const addToast = useMessageStore(state => state.addToast);
    
    const _deleteSuccessCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "The Check entry was succesfully deleted!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
        )
    
        refreshFunction();
    }
    
    const _deleteErrorCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "An error occured when deleting the Check entry.",
                autoHide: true,
                errorFlag: true,
                timestamp: Date.now() - 1000
            }
        )
    }

    const checkTotal = checks.reduce((acc,item) => acc + item.amount,0);
    const showEmptyState = !canAdd && checks.length === 0;

    return (
        <ExepnditureAccordion>
            <ExepnditureAccordionBody eventKey='0'>
                <ExepnditureAccordionToggle eventKey='0'>
                    <span className='d-flex justify-content-between align-items-center w-100'>
                        <span className='fw-bold'>CHECK</span>
                        <span>{formatDollars(checkTotal)}</span>
                    </span>
                </ExepnditureAccordionToggle>
                <ExepnditureAccordionCollapseSection>
                    <ListGroup>
                        {
                            canAdd
                            ?
                                <ListGroup.Item className={`${styles.expenditureListItem}`}>
                                    <div className='d-flex justify-content-center'>
                                        <Button type='button' variant='success' size='sm' title='Add Check Entry' aria-label='Add Check Entry' style={{ borderRadius: '50%' }} onClick={() => toggleAddEditMode(null, addEditIndex, 'add')}>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </Button>
                                    </div>
                                </ListGroup.Item>
                            :
                                null
                        }
                        {
                            showEmptyState
                            ?
                                <ListGroup.Item className={`${styles.expenditureListItem} text-center text-muted`}>
                                    No check entries to display.
                                </ListGroup.Item>
                            :
                                null
                        }
                        {
                            checks.map(check => {

                                return (
                                    <ListGroup.Item key={check.id} className={`${styles.expenditureListItem}`}>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span>{formatDollars(check.amount)}</span>
                                            <span>{check.createddate}</span>
                                        </div>
                                        <div className={styles.expenditureListItemText}>
                                            {check.itempurpose}
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span className={styles.expenditureListItemType}>
                                                {
                                                    _getExpenditureTypeText(check.expendituretypeid)
                                                }
                                            </span>
                                            <span className='d-flex'>
                                                <div>
                                                    <Button size="sm" type="button" variant="primary" className="me-1" title={canUpdate ? "Edit Check Entry" : "View Check Entry"} aria-label={canUpdate ? "Edit Check Entry" : "View Check Entry"} onClick={() => toggleAddEditMode(check.id, addEditIndex, canUpdate ? 'edit' : 'view')}>
                                                        <FontAwesomeIcon icon={canUpdate ? faPenToSquare : faEye} />
                                                    </Button>
                                                </div>
                                                {
                                                    canDelete
                                                    ?
                                                        <div >
                                                            <DeleteButton
                                                                deleteObject={{ApplicationID: ApplicationID,CheckID: check.id}}
                                                                endpoint="ExpenditureWorksheet_Check_Delete"
                                                                successCallback={_deleteSuccessCallback}
                                                                errorCallback={_deleteErrorCallback}
                                                            />
                                                        </div>
                                                    :
                                                        null
                                                }
                                            </span>
                                        </div>
                                    </ListGroup.Item>
                                );
                            })
                        }
                    </ListGroup>
                </ExepnditureAccordionCollapseSection>
            </ExepnditureAccordionBody>
        </ExepnditureAccordion>
    )
}

export default ExpenditureCheck;
